import React from 'react';

function Contact() {
    return (
        <div className="contact">
            <div className="contact-person">Samantha Small can be reached at <a href="mailto:sdsmall@michigandaily.com">sdsmall@michigandaily.com</a>.</div>
            <div className="contact-person">Sammy Sussman can be reached at <a href="mailto:sbsu@michigandaily.com">sbsu@michigandaily.com</a>.</div>
            <div className="contact-person">Zayna Syed can be reached at <a href="mailto:zasyed@michigandaily.com">zasyed@michigandaily.com</a>.</div>
        </div>
    );
}

export default Contact;